import { log } from "./logger";

const cache = {};

// Loads a public image as a PNG data URL + natural size for jsPDF.addImage. Resolves null on failure.
export async function loadLogo(path = "/logo.png") {
  if (cache[path]) return cache[path];
  try {
    const res = await fetch(path);
    const blob = await res.blob();
    const dataUrl = await new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(r.result);
      r.onerror = reject;
      r.readAsDataURL(blob);
    });
    const size = await new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve({ w: img.naturalWidth, h: img.naturalHeight });
      img.onerror = () => resolve({ w: 1, h: 1 });
      img.src = dataUrl;
    });
    cache[path] = { dataUrl, ...size };
    return cache[path];
  } catch (e) {
    log.warn("logo load failed", e);
    return null;
  }
}

// Draws the logo with a fixed height, preserving aspect ratio. Returns drawn width (mm).
export function drawLogo(doc, logo, x, y, height, align = "left") {
  if (!logo) return 0;
  const width = (logo.w / logo.h) * height;
  const drawX = align === "center" ? x - width / 2 : align === "right" ? x - width : x;
  doc.addImage(logo.dataUrl, "PNG", drawX, y, width, height);
  return width;
}
